export default "__VITE_ASSET__D3Nte8em__"